<div class="icon vg-icon-replay"
	[class.flip-icon]="BackOrForward === 'forward'"
	tabindex="0"
	role="button"
	[attr.aria-label]="BackOrForward === 'back'? 'skip backward' : 'skip forward'">
</div>
